import { Box, Text } from '@huspy/briks-web';
import { Divider } from '@huspy/styled-system/jsx';
import React from 'react';

type Props = {
  title: string;
  children: React.ReactNode;
};

const ProposalClientAndMortgageSectionBox = ({ title, children }: Props) => (
  <Box p='6' gap='4' bg='base.white' boxShadow='shadow-1' borderRadius='24px' w='100%'>
    <Box pb='6'>
      <Text py='1' size='lg' weight='medium'>
        {title}
      </Text>
      <Divider h='1' color='border-secondary' />
    </Box>
    <Box>
      {children}
    </Box>
  </Box>
);

export default ProposalClientAndMortgageSectionBox;
